import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Form } from 'antd';
import { connect } from 'dva';
import TextArea from 'antd/es/input/TextArea';
import { SelectInput } from '../../../../index';
import BottomActions from './BottomActions';
import styles from '../styles.less';

const FormItem = Form.Item;

function AdditionalInformation({ form, data, currentProject, dealClusters, dealTopics, dealTypes, onSubmit, goPrevStep, isUsingAgent }) {
  const { getFieldDecorator } = form;

  const handleSubmit = (e) => {
    e.preventDefault();

    form.validateFields((err) => {
      if (!err) {
        onSubmit(form.getFieldsValue());
      }
    });
  };

  const goBack = () => {
    goPrevStep(form.getFieldsValue());
  };

  return (
    <Form onSubmit={handleSubmit}>

      {/* Deal Cluster */}
      <FormItem
        label={<FormattedMessage id="Component.CreateHubspotTask.Form.DealClusterCustomField" />}
        style={{ display: currentProject.hubspot_create_deals ? 'block' : 'none' }}
        className={styles.formItem}
      >
        {getFieldDecorator('deal_cluster_custom_property', {
          initialValue: data.deal_cluster_custom_property,
          disabled: currentProject.hubspot_create_deals === false,
          rules: [{
            required: false,
          }],
        })(
          <SelectInput
            showArrow
            options={dealClusters}
          />,
        )}
      </FormItem>

      {/* Deal Category */}
      <FormItem
        label={<FormattedMessage id="Component.CreateHubspotTask.Form.DealTopicCustomField" />}
        style={{ display: currentProject.hubspot_create_deals ? 'block' : 'none' }}
        className={styles.formItem}
      >
        {getFieldDecorator('deal_category_custom_property', {
          initialValue: data.deal_category_custom_property,
          disabled: currentProject.hubspot_create_deals === false,
          rules: [{
            required: false,
          }],
        })(
          <SelectInput
            showArrow
            options={dealTopics}
          />,
        )}
      </FormItem>

      {/* Deal Type */}
      <FormItem
        label={<FormattedMessage id="Component.CreateHubspotTask.Form.DealTypeCustomField" />}
        style={{ display: currentProject.hubspot_create_deals ? 'block' : 'none' }}
        className={styles.formItem}
      >
        {getFieldDecorator('deal_type_custom_property', {
          initialValue: data.deal_type_custom_property,
          disabled: currentProject.hubspot_create_deals === false,
          rules: [{
            required: false,
          }],
        })(
          <SelectInput
            showArrow
            options={dealTypes}
          />,
        )}
      </FormItem>

      {/* Priority */}
      <FormItem
        label={<FormattedMessage id="Component.CreateHubspotTask.Form.Priority" />}
        className={styles.formItem}
      >
        {getFieldDecorator('hubspot_transfer_priority', {
          initialValue: data.hubspot_transfer_priority,
          rules: [{
            required: false,
          }],
        })(
          <SelectInput
            showArrow
            options={[
              { id: 'high', name: <FormattedMessage id="Component.CreateHubspotTask.Form.PriorityHigh" /> },
              { id: 'medium', name: <FormattedMessage id="Component.CreateHubspotTask.Form.PriorityMedium" /> },
              { id: 'low', name: <FormattedMessage id="Component.CreateHubspotTask.Form.PriorityLow" /> },
            ]}
          />,
        )}
      </FormItem>

      {/* Notes */}
      <FormItem
        label={<FormattedMessage id="Component.CreateHubspotTask.Form.NotesLabel" />}
        style={{ display: currentProject.hubspot_create_tasks ? 'block' : 'none' }}
        className={styles.formItem}
      >
        {getFieldDecorator('notes', {
          initialValue: data.notes,
          disabled: !currentProject.hubspot_create_tasks,
          rules: [{
            required: false,
            max: 1000,
          }],
        })(
          <TextArea />,
        )}
      </FormItem>

      <BottomActions goBack={goBack} backSuffix={isUsingAgent ? 'Back' : 'Close'} nextSuffix={'Next'} />
    </Form>
  );
}

AdditionalInformation.propTypes = {
  data: PropTypes.object,
  currentProject: PropTypes.object,
  dealClusters: PropTypes.array,
  dealTopics: PropTypes.array,
  dealTypes: PropTypes.array,
  onSubmit: PropTypes.func,
  goPrevStep: PropTypes.func,
  isUsingAgent: PropTypes.bool,
};

export default connect()(injectIntl(Form.create()(injectIntl(AdditionalInformation))));



// WEBPACK FOOTER //
// ./src/components/Leads/Hubspot/CreateHubspotTransferModal/components/AdditionalInformation.js